import { Icon, IconProps } from "@/base/components/icon/Icon.component";
import IconSvg from "./remove.svg?react";

export const RemoveIcon = (props: IconProps) => (
  <Icon component={IconSvg} {...props} />
);
